import { FeatureFlagValue } from '@sweetspot/shared/data-access/api-platform'

export enum FlagNames {
  DemoSweetspotUser = 'demo-sweetspot-user',
  RangeTeeTimePeriods = 'range-tee-time-periods',
  RangeBallDispensers = 'range-ball-dispensers',
  WebTeeSheetBookings = 'wb-tee-sheet-bookings',
  WebTeeSheetBookingItems = 'wb-tee-sheet-booking-items',
  GitClubSelect = 'git-club-select',
  ExperimentalClientKey = 'adyen-experimental-client-key',
  WebBookingApplePay = 'web-booking-apple-pay',
  IncludeBallsInBooking = 'include-balls-in-booking',
  NewLoginFlow = 'new-login-flow',
  DispenserPromotions = 'dispenser-promotions',
  ExtrasMenu = 'extras-menu',
  AcademyV2 = 'academy-2-0',
  NewCourseSettings = 'new-course-settings',
  CacheMiddleware = 'cache-middleware',
  PayOnSiteSetting = 'pay-on-site-setting',
}

// Add other types of flags if needed
export type Flag<T extends FlagNames> = Record<T, FeatureFlagValue>

export type FeatureFlags = {
  [K in FlagNames]: FeatureFlagValue
}
